import React, { useState } from 'react'
import Tick from '../assets/tick.svg'

const ProductReviewsTab = () => {
    const [selectedTab, setSelectedTab] = useState(1)

    return (
        <div className='w-full'>
            <div className='w-full flex justify-between md:justify-start md:gap-[100px] tetx-[24px] font-medium leading-[30px]'>
                <button
                    onClick={() => setSelectedTab(1)}
                    className={`pb-3 md:pb-4 border-b-[6px] text-[24px] leading-[34px] font-medium ${selectedTab === 1 ? "text-primary border-primary" : "border-transparent"}`}
                >
                    The Science
                </button>
                <button
                    onClick={() => setSelectedTab(2)}
                    className={`pb-3 md:pb-4 border-b-[6px] text-[24px] leading-[34px] font-medium ${selectedTab === 2 ? "text-primary border-primary" : "border-transparent"}`}
                >
                    Ingredients
                </button>
                <div></div>
            </div>
            <p className='border-black border-b-[3px] mt-[-3px]'></p>
            <div className='mt-6 md:mt-[60px]'>
                {
                    selectedTab === 2 ? <div className='flex flex-col gap-4'>
                        <div className='flex gap-1 items-center'>
                            <img src={Tick} alt="Tick" />
                            <p className='text-[14px] font-normal leading-[24px] text-secondary'>Organic Ashwagandha</p>
                        </div>
                        <div className='flex gap-1 items-center'>
                            <img src={Tick} alt="Tick" />
                            <p className='text-[14px] font-normal leading-[24px] text-secondary'>Organic Black Pepper</p>
                        </div>
                    </div> : <div className='text-start text-secondary'>
                        <p className='mb-4 text-[16px] font-normal leading-[26px] text-secondary'>
                            Experience the transformative benefits of Ashwagandha, a powerful adaptogen known for its ability to provide stress relief and reduce anxiety. This natural remedy may enhance sleep quality by resetting your circadian rhythm, while also improving cognitive function and memory. With its anti-inflammatory properties, Ashwagandha helps reduce chronic inflammation. As a general tonic, it promotes overall health, boosts energy levels, and supports longevity.
                        </p>
                        <div className='flex flex-col gap-2'>
                            <div className='flex gap-1 items-center'>
                                <img src={Tick} alt="Tick" />
                                <p className='text-[14px] font-normal leading-[24px] text-secondary'>Help Support Overall Health</p>
                            </div>
                            <div className='flex gap-1 items-center'>
                                <img src={Tick} alt="Tick" />
                                <p className='text-[14px] font-normal leading-[24px] text-secondary'>Support Healthy Hormone Level</p>
                            </div>
                            <div className='flex gap-1 items-center'>
                                <img src={Tick} alt="Tick" />
                                <p className='text-[14px] font-normal leading-[24px] text-secondary'>Help Combat Effects of Stress</p>
                            </div>
                            <div className='flex gap-1 items-center'>
                                <img src={Tick} alt="Tick" />
                                <p className='text-[14px] font-normal leading-[24px] text-secondary'>Normalize Mood & Energy Levels</p>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </div>
    )
}

export default ProductReviewsTab